import { NormalizedEntity } from 'Interfaces/Common';
import { RequestHistoryItem } from 'Interfaces/RequestsHistory';
import { createReducer } from 'typesafe-actions';

import { getRequestHistory } from './actionCreators';

export default createReducer({} as NormalizedEntity<RequestHistoryItem>).handleAction(
  getRequestHistory.success,
  (state, action) => ({
    ...action.payload.requestHistory,
  }),
);
